import { SET_SCREAMS, LOADING_DATA, LIKE_SCREAM, UNLIKE_SCREAM, DELETE_SCREAM, POST_SCREAM, SET_SCREAM, SUBMIT_COMMENT } from '../types';

const initialState = {
    screams: [],
    scream: {},
    loading: false
};

const dataReducer = (state = initialState, { type, payload }) => {
    let index;
    switch (type) {
        case LOADING_DATA:
            return {
                ...state,
                loading: true
            }
        case SET_SCREAMS:
            return {
                ...state,
                loading: false,
                screams: payload
            }
        case SET_SCREAM:
            return {
                ...state,
                scream: payload
            }
        case LIKE_SCREAM:
        case UNLIKE_SCREAM:
            index = state.screams.findIndex(scream => scream.screamId === payload.screamId);
            return {
                ...state,
                screams: state.screams.map((scream, screamIndex) =>
                    screamIndex === index ? payload : scream
                ),
                scream: state.scream.screamId === payload.screamId
                    ? payload
                    : state.scream
            }
        case DELETE_SCREAM:
            index = state.screams.findIndex(scream => scream.screamId !== payload.screamId);
            state.screams.splice(index, 1);
            return { ...state }
        case POST_SCREAM:
            return {
                ...state,
                screams: [payload, ...state.screams]
            }
        case SUBMIT_COMMENT:
            return {
                ...state,
                scream: {
                    ...state.scream,
                    comments: [payload, ...state.scream.comments]
                }
            }
        default:
            return state
    }
}

export default dataReducer;
